
import { JOUR_DEBUT_SEMAINE } from '@/configuration/datePickerConf';
import { getPropositions } from '@/api/reseaux';
import getAnneeSemaine, { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';

export default async function reseauDataPropositionInitializer(reseau,
  semaine, annee, dataProposition) {
  try {
    if (dataProposition) {
      reseau.dataProposition = dataProposition;
      return;
    }
    // on fait un -1 car getDateByJourAnneeSemaine fait +1
    const jourDepart = JOUR_DEBUT_SEMAINE - 1;
    const dateStart = getDateByJourAnneeSemaine(jourDepart, annee, semaine).format('YYYYMMDD');
    const dateEnd = getDateByJourAnneeSemaine(
      jourDepart + 6 * reseau.dureeConservation,
      annee, semaine).format('YYYYMMDD');
    const libelle = getAnneeSemaine(annee, semaine);
    const response = await getPropositions(dateStart, dateEnd, [reseau.num]);
    if (response.data[reseau.num]) {
      reseau.dataProposition = response.data[reseau.num][libelle];
      if (reseau.dataProposition.tarifBrut == null) {
        reseau.dataProposition.tarifBrut = reseau.tarifBrut;
      }
      if (reseau.dataProposition.tarifTaxes == null) {
        reseau.dataProposition.tarifTaxes = reseau.tarifTlpe;
      }
    }
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/services/catalogue/reseauDataPropositionInitializer.js